import React from "react";
import PropTypes from "prop-types";
import { Card, CardContent, Typography, Skeleton } from "@mui/material";
import { formatCurrency } from "./formatters";

// Matches the KPI card precedent already established in src/app/dashBoard/index.js
// (Card + CardContent, colored background, h4 value / h6 label).
const KpiCard = ({ label, value, color = "#17a2b8", currency = false, loading }) => {
  const displayValue = currency ? formatCurrency(value) : value;

  return (
    <Card style={{ backgroundColor: color, color: "#fff", minWidth: "200px" }}>
      <CardContent>
        {loading ? (
          <Skeleton variant="text" width="60%" height={40} sx={{ bgcolor: "rgba(255,255,255,0.3)" }} />
        ) : (
          <Typography variant="h4">{displayValue}</Typography>
        )}
        <Typography variant="h6" sx={{ marginTop: ".5rem" }}>
          {label}
        </Typography>
      </CardContent>
    </Card>
  );
};

KpiCard.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
  currency: PropTypes.bool,
  loading: PropTypes.bool,
};

export default KpiCard;
